<div
    mat-dialog-content
    class="nova__dialog__content"
    [style.width.px]="width"
    [style.height.px]="height"
    [style.max-height.px]="maxHeight"
    (scroll)="onScroll($event)"
>
    <ng-content></ng-content>
</div>
